module.exports = __webpack_public_path__ + "img/5fa77ee.png";